export default __webpack_public_path__ + "static/media/logo-mysql.098f54de.png";